import React, { useState } from "react";

export default function CustomTextArea({
  label,
  required = false,
  name,
  id,
  value,
  onChange,
  autoComplete = "off",
  disabled = false,
  onKeyDown,
  error = false,
  rows = 4,
  bgColor,
}) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="relative">
      <textarea
        rows={rows}
        disabled={disabled}
        name={name}
        id={id}
        onChange={onChange}
        value={value ? value : ""}
        autoComplete={autoComplete}
        className="block w-full px-12 py-18 text-xxs font-medium leading-115 tracking-05 rounded-xxxs text-gray-700 bg-transparent ring-1 ring-inset ring-gray-500 focus:outline-none focus-visible:outline-none"
        onKeyDown={onKeyDown}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <label
        htmlFor={id}
        className={`absolute left-12 pointer-events-none text-xxs font-medium leading-115 tracking-05 text-gray-700 duration-100 ${bgColor} origin-top-left ${
          isFocused || value ? "-top-10 scale-90" : "top-15"
        }`}
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      {error && <span className="block small text-red-500 mt-4">{error}</span>}
    </div>
  );
}
